(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["catalog"]) return;
  try {
    
  if (!customElements.get('gb-collection-loader')) {
    customElements.define('gb-collection-loader', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.grid = this.querySelector('[data-catalog-grid]');
        this.button = this.querySelector('[data-load-more]');
        this.error = this.querySelector('[data-load-error]');
        this.label = this.button.textContent;
        this.button.hidden = !this.dataset.next;
        this.button.addEventListener('click', () => this.loadMore());
      }

      productKey(card) {
        const link = card.querySelector('a[href]');
        return link ? new URL(link.getAttribute('href'), location.href).pathname : '';
      }

      async loadMore() {
        if (this.busy || !this.dataset.next) return;
        this.busy = true;
        this.button.disabled = true;
        this.button.textContent = this.dataset.loading;
        this.grid.setAttribute('aria-busy', 'true');
        this.error.hidden = true;
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 20000);
        try {
          const next = new URL(this.dataset.next, location.href);
          const url = new URL(location.href);
          const pageParam = this.dataset.pageParam;
          url.searchParams.set(pageParam, next.searchParams.get(pageParam));
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Collection request failed');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incoming = Array.from(doc.querySelectorAll('gb-collection-loader')).find(el => el.dataset.sectionId === this.dataset.sectionId);
          if (!incoming || Number(incoming.dataset.page) !== Number(this.dataset.page) + 1) throw new Error('Invalid collection page');
          const cards = Array.from(incoming.querySelector('[data-catalog-grid]').children);
          const seen = new Set(Array.from(this.grid.children).map(card => this.productKey(card)));
          const fresh = cards.filter(card => {
            const key = this.productKey(card);
            if (!key || seen.has(key)) return false;
            seen.add(key);
            return true;
          });
          if (!fresh.length) throw new Error('No new products returned');
          this.grid.append(...fresh);
          this.dataset.page = incoming.dataset.page;
          this.dataset.total = incoming.dataset.total;
          this.dataset.next = incoming.dataset.next;
          const viewed = this.grid.children.length;
          const total = Number(this.dataset.total);
          this.querySelector('[data-viewed]').textContent = viewed;
          this.querySelector('[data-total]').textContent = total;
          this.querySelector('[data-progress]').style.width = `${total ? Math.min(100, viewed / total * 100) : 0}%`;
          const focusTarget = fresh[0].querySelector('a[href]');
          if (document.activeElement === this.button && focusTarget) focusTarget.focus({ preventScroll: true });
          this.button.hidden = !this.dataset.next;
        } catch (error) {
          this.error.hidden = false;
        } finally {
          clearTimeout(timeout);
          this.busy = false;
          this.button.disabled = false;
          this.button.textContent = this.label;
          this.grid.removeAttribute('aria-busy');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
